import axios from "axios";

const instance = axios.create({
  baseURL: "/", // API 기본 URL 설정
  withCredentials: true, // 쿠키 포함
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// Refresh Token 요청 함수
const refreshAccessToken = async () => {
  // console.log("Attempting to refresh access token...");
  try {
    const response = await instance.post("/api/user/refresh-token");
    const newAccessToken = response.data.data;
    // console.log("Access token refreshed successfully:", newAccessToken);
    return newAccessToken;
  } catch (err) {
    console.error("Failed to refresh access token:", err);
    throw err;
  }
};

// Axios 인터셉터 설정
instance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => {
    // console.log("Response intercepted:", response);
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      console.warn("401 error intercepted:", error.response.data);

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(() => instance(originalRequest))
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const newAccessToken = await refreshAccessToken();
        processQueue(null, newAccessToken);

        return instance(originalRequest);
      } catch (refreshError) {
        console.error("Failed to refresh token. Redirecting to login.");
        processQueue(refreshError, null);
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
